<template>
  <v-card :class="[$root.device.isMobile ? 'mobileContent' : 'fullContentRTL']">
    <v-toolbar dark color="primary" class="fullToolbar">
      <v-toolbar-title class="white--text" style="font-size: 30px; text-align: right; position: relative;">
        <i class="material-icons icon">chat</i>הודעות
        
      </v-toolbar-title>
      <div v-if="$root.messagesCounter" class="w3-badge" style="position: absolute; right: 140px;"><b>{{$root.messagesCounter}}</b></div>
      <v-spacer></v-spacer>
      <v-text-field v-if="!$root.device.isMobile" dark prepend-icon="search" single-line style="padding-top: 20px;" v-model="txtSearch"></v-text-field>
      <v-icon v-else @click="$root.activeMobileMenu=true" class="btnIcon mr-2 ml-2">menu</v-icon>
    </v-toolbar>
    

    <div v-if="$root.device.isMobile" style="width: 100%;">
      <table class="w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable" style="padding: 20px!important; border:none; width: 100%;">
        <tr class="trPrint trHeader">
          <th>הודעות ובקשות הצטרפות ליומן...</th>
        </tr>
      </table>
      <div class="scrollContentMobile" v-if="hasData">
        <div class="note msg" v-for="row in filteredRows">
          <v-layout row wrap style="padding: 5px;">
            <v-flex xs6>
              <b>{{row.SenderName}}</b>:
            </v-flex>
            <v-flex xs6 style="text-align: left;color: #aaa; font-size: 14px;">
              {{row.CreateDate}}
            </v-flex>
          </v-layout>
          <v-layout row wrap style="padding: 5px;">
            <v-flex xs12 right style="text-align: right; padding-right: 10px;">
              {{row.Text}}
            </v-flex>
          </v-layout>
          <div style="width: 100%;height: 30px;">
            <v-icon style="float: right;" v-if="row.IsConfirmed" class="green--text">done</v-icon>
            <v-icon style="float: right;" v-else class="red--text">block</v-icon>
            <label v-if="row.IsConfirmed" class="green--text">מאושר</label>
            <label v-else class="red--text">לא מאושר</label>
            <v-icon style="float: left;" v-if="!row.IsConfirmed" @click="confirmMessage(row)" class="btnIcon mr-2 ml-2" v-tooltip:bottom="{ html: 'אישור בקשה' }">check_circle</v-icon>
          </div>
        </div>
      </div>
      <div fluid v-else>
        <h3 style="padding-top: 40px;">אין נתונים</h3>
      </div>
    </div>

    <div v-else style="width: 100%;">
      <table class="w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable" style="padding: 20px!important; border:none; width: 100%;">
        <tr class="trPrint trHeader">
          <th class="tdData sp">תאריך</th>
          <th class="tdData">השולח</th>
          <th class="tdData" style="width: 480px;">תוכן ההודעה</th>
          <th class="tdData" v-if="!$root.device.isMobile">סוג הודעה</th>
          <th class="tdCtrl" v-if="hasData" style="width: 100px!important;">מאושר</th>

          <th class="tdCtrl" style="width: 160px!important;"></th>
        </tr>
      </table>
      <div class="scrollContent" v-if="hasData">
        <table class="w3-table-all w3-hoverable w3-small w3-right-align elevation-1" style="border:none;">
          <tr v-for="row in filteredRows">
            <td class="tdData sp">{{row.CreateDate}}</td>
            <td class="tdData">{{row.SenderName}}</td>
            <td class="tdData tdTxt" style="width: 500px;">{{row.Text}}</td>
            <td class="tdData tdTxt" v-if="!$root.device.isMobile">{{row.Type}}</td>
            <td class="tdCtrl" style="width: 100px!important;">
              <v-icon v-if="row.IsConfirmed" class="green--text">done</v-icon>
              <v-icon v-else class="red--text">block</v-icon>
            </td>
            <td class="tdCtrl tdTxt" style="width: 160px!important;">
              <v-icon v-if="!row.IsConfirmed" @click="confirmMessage(row)" class="btnIcon mr-2 ml-2" v-tooltip:bottom="{ html: 'אישור בקשה' }">check_circle</v-icon>
              <!--<v-icon @click="confirm(row)" class="btnIcon mr-2 ml-2" v-tooltip:bottom="{ html: 'מחיקה' }">delete</v-icon>-->
            </td>
          </tr>
        </table>
      </div>
      <div fluid v-else>
        <h3 style="padding-top: 40px;">אין נתונים</h3>
      </div>
    </div>


  </v-card>
</template>

<script>

  import { db } from '../firebase';
  var messagesRef = db.ref('Messages');

  export default {
    name: 'Messages',
    data() {
      return {
        txtSearch: '',
        messages: [],
        isActiveUsers: false,
        popup: {
          isVisible: false,
          title: '',
          question: '',
          caller: '',
          isConfirmed: false,
          data: { '.key': '' },
        }
      }
    },
    firebase: function () {
      var vm = this;
      return {
        messages: messagesRef.orderByChild("ToUserKey").equalTo(vm.$root.user['.key'])
      }
    },
    created() {
      this.$Log("Vue [Messages] is created ...");
    },
    ready() {
      this.$Log("Vue [Messages] is ready ...");
    },
    mounted() {
      this.$Log("Vue [Messages] is mounted ...");
    },
    updated() {
      this.$Log("Vue [Messages] is updated ...");
    },
    computed: {
      hasData() {
        return this.filteredRows != null && this.filteredRows != undefined && this.filteredRows.length > 0;
      },
      filteredRows() {
        var vm = this;
        if (vm.txtSearch.length > 0) {
          var result = [];
          try {
            result = vm.messages.filter(function (row) {
              return Object.keys(row).some(function (key) {
                if (String(row[key]).trim().toLowerCase().indexOf(vm.txtSearch.trim().toLowerCase()) > -1) {
                  if (vm.isActiveUsers) {
                    if (row.Active) {
                      return row;
                    }
                  }
                  else {
                    return row;
                  }
                }
              })
            });
          }
          catch (e) {
          }
        }
        else {
          result = vm.messages;
        }
        //else {
        //  if (vm.isActiveUsers) {
        //    result = vm.messages.filter(function (row) {
        //      if (row.Active) {
        //        return row;
        //      }
        //    });
        //  }
        //  else {
        //    result = vm.messages;
        //  }
        //}

        return result;
      }
    },
    watch: {
      '$root.confirm.isConfirmed'(val) {
        if (val && this.$root.confirm.caller == 'RemoveMessage') {
          this.remove();
        }
        if (val && this.$root.confirm.caller == 'ConfirmMessage') {
          this.confirmYesMessage();
        }
      },
      messages(val) {
        if (val) {
          this.$root.messagesCounter = 0;
          for (var m = 0; m < this.messages.length; m++) {
            if (!this.messages[m].IsConfirmed) {
              this.$root.messagesCounter++;
            }
          }
        }
      }
    },
    methods: {
      edit(row) {
        this.popup = {
          isVisible: true,
          isEdit: true,
          title: 'עריכת מפקח',
          data: {
            '.key': row['.key'],
            FullName: row.FullName,
            Username: row.Username,
            Identity: row.Identity,
            Type: row.Type,
            Password: row.Password,
            Active: row.Active,
            Approved: row.Approved
          }
        };
      }, 
      confirmMessage(row) {
        this.popup.data = row;
        this.$root.confirm = {
          isVisible: true,
          title: 'אישור',
          question: 'האם אתה בטוח ברצונך לאשר בקשה זו?',
          caller: 'ConfirmMessage',
          isConfirmed: false
        }
      },
      confirm(row) {
        this.popup.data['.key'] = row['.key'];
        this.$root.confirm = {
          isVisible: true,
          title: 'מחיקה',
          question: 'האם אתה בטוח ברצונך למחוק שורה זו?',
          caller: 'RemoveMessage',
          isConfirmed: false
        }
      },
      remove() {
        messagesRef.child(this.popup.data['.key']).remove();
      },
      confirmYesMessage() {
        var vm = this;
        var diaryRef = db.ref('Diaries/' + vm.popup.data.DiaryKey + "/AddedUsers");
        //alert(vm.popup.data.ToUserKey)
        var addedUsers = diaryRef.orderByChild("UserKey").equalTo(vm.popup.data.ToUserKey).once('value').then(function (snapshot) {
          let obj = snapshot.val();
          //alert(diaryRef)
          if (obj) {
            let key = Object.keys(obj)[0];
            //var addedUserRef = db.ref('Diaries/' + vm.popup.data.DiaryKey + "/AddedUsers/" + key);
            //addedUserRef.child("IsConfirmed").set(true);
            //messagesRef.child(vm.popup.data['.key']).child("IsConfirmed").set(true);
            //alert(key)
            let addedUserPath = 'Diaries/' + vm.popup.data.DiaryKey + '/AddedUsers/' + key + '/IsConfirmed';
            let messagePath = 'Messages/' + vm.popup.data['.key'] + '/IsConfirmed';
            let updateObj = {};
            updateObj[addedUserPath] = true;
            updateObj[messagePath] = true;

            //alert(JSON.stringify(updateObj))
            db.ref().update(updateObj);
          }
        });
      },
      insert() {
        var item = {
          FullName: this.popup.data.FullName,
          Username: this.popup.data.Username,
          Identity: this.popup.data.Identity,
          Type: this.popup.data.Type,
          Password: this.popup.data.Password,
          Active: this.popup.data.Active,
          Approved: this.popup.data.Approved
        };

        messagesRef.push(item);
      },
      update() {
        var item = {
          FullName: this.popup.data.FullName,
          Username: this.popup.data.Username,
          Identity: this.popup.data.Identity,
          Type: this.popup.data.Type,
          Password: this.popup.data.Password,
          Active: this.popup.data.Active,
          Approved: this.popup.data.Approved
        };
        messagesRef.child(this.popup.data['.key']).set(item);
      }
    }
  }

</script>
<style>

  .msg {
    font-size: 16px;
    padding: 5px;
    margin: 10px;
  }

</style>



// WEBPACK FOOTER //
// Messages.vue?82a19bc6